// Transform an image URL to a sized version.
//
// Ghost/R2-hosted images are resized at the edge by the Cloudflare Content Worker,
// which reads a `?w=` query param. Ghost's own /content/images/size/w{n}/ form does
// NOT work here: the ghos3 storage adapter cannot resize, and this blog's images are
// not under /content/images/ at all (they are /content/<year>/<month>/...), so the
// old code silently returned the URL unchanged and shipped full-size originals.
// Format is negotiated from the browser's Accept header, so no format param.
export function ghostImageUrl(url, width) {
  if (!url || !width) return url;

  // Unsplash resizes via its own query params.
  if (url.includes('images.unsplash.com')) {
    let result = url.includes('&w=')
      ? url.replace(/&w=\d+/, `&w=${width}`)
      : `${url}&w=${width}`;
    result = result.includes('&fm=')
      ? result.replace(/&fm=\w+/, '&fm=webp')
      : `${result}&fm=webp`;
    return result;
  }

  if (url.includes('/content/')) {
    const [base, query = ''] = url.split('?');
    const params = new URLSearchParams(query);
    params.set('w', String(width)); // overrides any existing w=, keeps other params
    return `${base}?${params.toString()}`;
  }

  return url;
}

// Build a srcset string for Ghost images
export function ghostImageSrcset(url, widths) {
  return widths.map(w => `${ghostImageUrl(url, w)} ${w}w`).join(', ');
}
